import React from 'react';
import { LineChartIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="w-full py-20 px-4 bg-brand-bg" data-id="element-233">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-brand-card to-brand-bg border border-brand-gold/20 rounded-2xl p-8 md:p-12 text-center shadow-2xl relative overflow-hidden" data-id="element-234">
        <div className="absolute -top-24 -right-24 w-48 h-48 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-235" />
        <div className="absolute -bottom-24 -left-24 w-48 h-48 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-236" />

        <LineChartIcon className="w-16 h-16 text-brand-gold mx-auto mb-8 relative z-10" data-id="element-237" />

        <p className="text-xl md:text-2xl text-brand-text leading-relaxed font-medium relative z-10" data-id="element-238">
          En los próximos 7 días, dejarás de apostar por intuición… y empezarás
          a detectar oportunidades reales.
        </p>
        <p className="text-xl md:text-2xl text-brand-text leading-relaxed font-medium mt-6 relative z-10" data-id="element-239">
          Vas a dejar de fijarte en nombres de equipos y empezarás a ver lo que
          realmente importa: errores del mercado que puedes aprovechar.
        </p>
        <p className="text-lg md:text-xl text-brand-muted mt-6 leading-relaxed relative z-10" data-id="element-240">
          Al aplicar este sistema, ya no dependerás de la suerte. Solo entrarás
          en jugadas donde tienes ventaja matemática sobre la casa.
        </p>
      </div>
    </section>;
}